import React, { FC, memo, useMemo } from 'react';
import { Button } from '~Styles';
import { useButton, useI18n } from '~Hooks';
import { useInventoryUniverse } from '~Components/InventoryUniverse';
import useModal from '~ComponentsImproved/Modal/useModal';
import Modal from '~ComponentsImproved/Modal';
import Details from '~Scenes/POS/Components/Inventory/Details';

interface Props {
  itemId: string;
  venueId: string;
  title: string;
  description: string;
  imageUrl?: string;
}

const ProductActions: FC<Props> = ({ itemId, venueId, title, description, imageUrl }) => {
  const { i18n } = useI18n();
  const inventory = useInventoryUniverse();
  const detailsModal = useModal();

  const actionsButton = useButton({
    onClick: () => detailsModal.toggle(),
  });

  const inventoryStatus = useMemo(() => {
    const inventoryItem = inventory.items.find((i) => i.itemId === itemId);

    if (inventoryItem) {
      return {
        count: inventoryItem.count,
        outOfStock: inventoryItem.outOfStock,
      };
    }

    return {
      count: null,
      outOfStock: false,
    };
  }, [inventory, itemId]);

  return (
    <>
      <Button {...actionsButton} padding="small">
        {i18n('Inventory.Actions')}
      </Button>

      {detailsModal.isShowing && (
        <Modal isShowing={true} backdropClose={true}>
          <Details
            id={itemId}
            title={title}
            venueId={venueId}
            isOutOfStock={inventoryStatus.outOfStock}
            onCancel={() => detailsModal.toggle()}
            defaultValue={inventoryStatus.count ?? 0}
            description={description}
            imageUrl={imageUrl}
          />
        </Modal>
      )}
    </>
  );
};

export default memo(ProductActions);
